module.exports = __webpack_public_path__ + "img/ising-line-short.4fdce863.svg";